<template lang="pug">
div.task-point-create-edit.p1
  ProductSelect(ref="pointSelector" v-model="itemList" :target="target" @change="handleproductChange")
  CustomProduct(ref="customProduct" :target="target" @modal-success="handleCustomProduct")
  SelectRealProduct(ref="real" :target="target"  v-model="model.productDTO" :orderItem="model" @change="handleRealProduct")
  ProductCommentsEdit(ref="productCommentsEdit"  :target.sync="target" @change="e => $emit('update:target', e)")
  //- div.mb2(style="text-align: right;" v-if="!target || !target.id")
  div.mb2(style="text-align: right;" v-if="!detailMode && (post === 'orderReceiver' || !target || !target.id)")
    a-button(type="primary" @click="$refs.pointSelector.show(itemList)") 添加产品
    a-button.ml2(type="primary" @click="$refs.customProduct.show()") 添加未收录产品
    //- a-button.ml2(type="danger" @click="handleDeleteBatch" :disabled="!canDeleteBatch") 批量删除

  app-custom-table(
    ref="table"
    :tableData="itemList"
    :tableColumns="tableColumns"
    noPagination
    :selectionMode="false"
  )
</template>

<script>
import ProductSelect from './ProductSelect';
import ProductCommentsEdit from './ProductCommentsEdit';
import CustomProduct from './CustomProduct';
import SelectRealProduct from './SelectRealProduct';

import { GETTER_PROJECT, GETTER_USER } from '@store/account';
import { mapGetters } from 'vuex';

import _ from 'lodash';
export default {
  name: 'ProductDTOS',
  components: {
    ProductSelect,
    ProductCommentsEdit,
    CustomProduct,
    SelectRealProduct,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: Array,
    productDTOS: Array,
    target: Object,
    detailMode: Boolean,
    post: String,
  },
  data() {
    return {
      itemList: [],
      model: {
        objectType: null,
        objectKey: null,
        standardIds: [], // 标准
      },
      rules: {
        objectType: [{ required: true, message: '必填项' }],
        objectKey: [{ required: true, message: '必填项' }],
      },
      showForm: false,
      isAdd: false,
      editIndex: -1,

      // 自定义表格列
      tableColumns: [],
      // 批量删除
      canDeleteBatch: false,
    };
  },
  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
      user: GETTER_USER,
    }),
    params() {
      return {
        projectId: this.project.id,
      };
    },
  },
  watch: {
    value: 'handleValueChange',
    productDTOS() {
      this.itemList = this.productDTOS || [];
    },
  },
  created() {
    // 初始化
    this.itemList = this.productDTOS || [];
    this.handleValueChange();
    this.initTableColumns();
    this.initFilters();
  },
  methods: {
    handleValueChange() {
      // this.itemList = this.value || [];
    },
    handleproductChange() {
      this.change();
    },
    handleCustomProduct(customProduct) {
      this.itemList.push({
        productId: customProduct.productId || customProduct.id,
        productComments: customProduct.productComments || '',
        quantity: customProduct.quantity || 1,
        productDTO: customProduct.productDTO || customProduct,
      });
    },
    handleRealProduct(product) {
      this.model.productId = product?.id;
      this.model.productName = product?.name;
      // this.model = {
      //   ...this.model,
      //   productId: product?.id,
      //   productName: product?.name,
      // };
      // this.productId = product?.id;
      // console.log({ ...this.model });
    },
    handleDelete(index) {
      // this.$restful(`DELETE:/ops/inspcontents-item/${this.itemList[index].id}`);
      const item = this.itemList.splice(index, 1)[0];
      if (item?.id) {
        this.$emit('delete-item', item.id);
      }
      this.change();
    },
    handleClickAdd() {
      this.showForm = true;
      this.isAdd = true;
      this.$emit('click-add-item');
    },
    handleEdit(index) {
      this.showForm = true;
      this.isAdd = false;
      this.editIndex = index;
      // this.model = {
      //   ...this.itemList[index],
      // };
      this.model = _.cloneDeep(this.itemList[index]);
      console.log(this.model);
    },
    async handleSave() {
      console.log(this.model.selections, 'selectedItems');
      this.itemList.splice(this.editIndex, 1, {
        ...this.model,
      });
      this.change();
      this.showForm = false;
      this.isAdd = false;
      this.editIndex = -1;
      this.reset();
    },
    handleCancel() {
      this.showForm = false;
      this.isAdd = false;
      this.reset();
    },
    reset() {
      this.model = {
        name: null,
        resultType: null,
      };
      this.$refs.form?.resetFields();
      this.$refs.form?.clearValidate();
    },
    change() {
      this.$emit('update:pointDTOS', this.itemList);
      this.$emit(
        'change',
        this.itemList.map((item) => {
          return {
            id: item.id || '',
            productId: item.productId || item.id,
            quantity: item.quantity || item.productDTO.availableQuantity || 1,
            productDTO: item.productDTO || item,
            productComments:
              item.productComments || item.productDTO.inventoryComments || '',
            customerOrderCode:
              item.customerOrderCode || item.productDTO.customerOrderCode || '',
            warehouseId: item.warehouseId || item.productDTO.warehouseId || '',
            warehousePartitionId:
              item.warehousePartitionId ||
              item.productDTO.warehousePartitionId ||
              '',
            inventoryId: item.inventoryId || item.productDTO.inventoryId || '',
          };
        }),
      );
    },
    // 批量删除产品
    handleDeleteBatch() {},
    // 初始化表格 列
    initTableColumns() {
      this.tableColumns = [
        {
          uid: 'name',
          dataIndex: 'name',
          title: '产品名称',
          customClass: ['pl2'],
          width: '150px',
          render(h, v, r) {
            return r.productDTO.name;
          },
        },
        {
          uid: 'quantity',
          dataIndex: 'quantity',
          title: '产品数量',
          width: '100px',
          render: (h, v, r, index) => {
            return this.target?.id ? (
              v
            ) : (
              <div
                onClick={(e) => {
                  e?.stopPropagation();
                }}
              >
                <a-input-number
                  value={v}
                  onChange={(e) => {
                    // console.log(e);
                    v = e;
                    this.itemList[index].quantity = e;
                    this.change();
                  }}
                />
              </div>
            );
          },
        },
        {
          uid: 'customerOrderCode',
          dataIndex: 'customerOrderCode',
          title: '客户订单号',
          width: '150px',
          render: (h, v, r, index) => {
            return this.target?.id ? (
              v || '--'
            ) : (
              <div
                onClick={(e) => {
                  e?.stopPropagation();
                }}
              >
                <a-input
                  value={v}
                  onChange={(e) => {
                    // console.log(e);
                    v = e.target.value;
                    this.itemList[index].customerOrderCode = e.target.value;
                    this.change();
                  }}
                />
              </div>
            );
          },
        },
        {
          uid: 'productComments',
          dataIndex: 'productComments',
          title: '备注',
          width: 'auto',
          flex: 1,
          render: (h, v, r, index) => {
            return this.target?.id ? (
              v || '--'
            ) : (
              <div
                onClick={(e) => {
                  e?.stopPropagation();
                }}
              >
                <a-input
                  value={v}
                  onChange={(e) => {
                    // console.log(e);
                    v = e.target.value;
                    this.itemList[index].productComments = e.target.value;
                    this.change();
                  }}
                />
              </div>
            );
          },
        },
      ];
      if (!this.detailMode) {
        this.tableColumns.push({
          uid: 'actions',
          dataIndex: 'actions',
          title: '操作',
          width: '60px',
          render: (h, v, r, index) => {
            if (r.productId) {
              if (this.target?.id && this.post !== 'orderReceiver') {
                // return (
                //   <div>
                //     <app-link-btn
                //       title="匹配产品"
                //       onClick={(e) => {
                //         e.stopPropagation();
                //         this.model = r;
                //         this.$refs.real.show(r);
                //       }}
                //     >
                //       匹配产品
                //     </app-link-btn>
                //   </div>
                // );
                return '--';
              } else {
                return (
                  <div>
                    <app-link-btn
                      title="删除"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.handleDelete(index);
                      }}
                    >
                      删除
                    </app-link-btn>
                  </div>
                );
              }
            } else {
              if (this.target?.id) {
                return '--';
              } else {
                return (
                  <div>
                    <app-link-btn
                      title="删除"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.handleDelete(index);
                      }}
                    >
                      删除
                    </app-link-btn>
                  </div>
                );
              }
            }
          },
        });
      }
    },
    //
    initFilters() {},
  },
};
</script>

<style lang="less" scoped>
.task-point-create-edit {
  // margin-left: -90px;
  // margin-top: -4px;
  // width: calc(100% + 90px);
  .insp-item-list {
    // display: ;
    .insp-item-list-head,
    .insp-item-list-body {
      text-align: center;
      .item-name,
      .item-type,
      .item-config,
      .item-action {
        padding: 8px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        word-break: break-all;
      }
      .item-name {
        flex: 1;
      }
      .item-type {
        flex: 1;
        border-left: 1px solid rgba(0, 0, 0, 0.1);
      }
      .item-config {
        flex: 3;
        border-left: 1px solid rgba(0, 0, 0, 0.1);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .item-action {
        flex: 1;
        border-left: 1px solid rgba(0, 0, 0, 0.1);
      }
    }
    .insp-item-list-head {
      color: rgba(0, 0, 0, 0.85);
      border: 1px solid rgba(0, 0, 0, 0.1);
      background-color: rgba(0, 0, 0, 0.05);
    }
    .insp-item-list-body {
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-top-width: 0;
    }
    .item-row {
      justify-content: stretch;
      & + .item-row {
        border-top: 1px solid rgba(0, 0, 0, 0.1);
      }
    }
  }
  .insp-object {
    .insp-object-name {
      font-size: 16px;
      font-weight: 600;
    }
  }
}
</style>
